import { WSList } from "@wingspanhq/fe-component-library";
import {
  SharedFileRequest,
  SharedFileRequestContextType,
  SharedFileRequestJobType
} from "@wingspanhq/wingspan-api-sdk";

import { WayfinderWidget } from "../../../../../../shared/components/WayfinderWidget";
import { AIValidationWidget } from "../../../../components/AIValidationWidget";
import { RequirementContextType } from "../../../../types";
import { AssurelyWidget } from "../AssurelyWidget";

type Props = {
  sharedFileRequest: SharedFileRequest;
  contextType: RequirementContextType;
};

/**
 * Previews the PLANNED validations before anything is uploaded, off the
 * shared-file-request *configuration*'s `jobs` — the reusable template's list.
 *
 * A request's own `jobs` only materialise once a file was uploaded, and those
 * carry live status; SharedFileDetailsWidgetsContainer renders those instead.
 *
 * The configuration arrives inline on the request as `_configuration`, so this
 * needs no second read and resolves on either seat. It previously walked the
 * requirement definition to the configuration, and both of those are payer-owned
 * and 404 for a contractor — so the walk was gated to the payee context and the
 * preview never rendered at all.
 */
export const SharedFileInstructionsWidgetsContainer: React.FC<Props> = ({
  sharedFileRequest,
  contextType
}) => {
  // Do not show any widgets for DocumentUpload requirement type if contextType is None
  if (sharedFileRequest.contextType === SharedFileRequestContextType.NONE) {
    return null;
  }

  const validationJobs = (sharedFileRequest._configuration?.jobs ?? []).filter(
    job => job.type === SharedFileRequestJobType.VALIDATION
  );

  if (!validationJobs.length) {
    return null;
  }

  return (
    <WSList gap="L">
      {contextType === RequirementContextType.Payer ? <AssurelyWidget /> : null}
      <AIValidationWidget
        contextType={contextType}
        validationItems={validationJobs}
      />
      {contextType === RequirementContextType.Payee ? (
        <WayfinderWidget />
      ) : null}
    </WSList>
  );
};
